import api from './api';

const locationsService = {
  // Get all cities with areas and districts
  getAllCities: async () => {
    try {
      const response = await api.get('/admin/locations/cities');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Add a new city
  addCity: async (arLabel, enLabel) => {
    try {
      const response = await api.post('/admin/locations/cities', { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update a city
  updateCity: async (cityId, arLabel, enLabel) => {
    try {
      const response = await api.put(`/admin/locations/cities/${cityId}`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete a city
  deleteCity: async (cityId) => {
    try {
      const response = await api.delete(`/admin/locations/cities/${cityId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Add an area to a city
  addArea: async (cityId, arLabel, enLabel) => {
    try {
      const response = await api.post(`/admin/locations/cities/${cityId}/areas`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update an area
  updateArea: async (cityId, areaId, arLabel, enLabel) => {
    try {
      const response = await api.put(`/admin/locations/cities/${cityId}/areas/${areaId}`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete an area
  deleteArea: async (cityId, areaId) => {
    try {
      const response = await api.delete(`/admin/locations/cities/${cityId}/areas/${areaId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Add a district to an area
  addDistrict: async (areaId, arLabel, enLabel) => {
    try {
      const response = await api.post(`/admin/locations/areas/${areaId}/districts`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Add a district directly to a city (no area)
  addDistrictToCity: async (cityId, arLabel, enLabel) => {
    try {
      const response = await api.post(`/admin/locations/cities/${cityId}/districts`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update a district
  updateDistrict: async (areaId, districtId, arLabel, enLabel) => {
    try {
      const response = await api.put(`/admin/locations/areas/${areaId}/districts/${districtId}`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update a district (city-level)
  updateDistrictByCity: async (cityId, districtId, arLabel, enLabel) => {
    try {
      const response = await api.put(`/admin/locations/cities/${cityId}/districts/${districtId}`, { arLabel, enLabel });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete a district
  deleteDistrict: async (areaId, districtId) => {
    try {
      const response = await api.delete(`/admin/locations/areas/${areaId}/districts/${districtId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete a district (city-level)
  deleteDistrictByCity: async (cityId, districtId) => {
    try {
      const response = await api.delete(`/admin/locations/cities/${cityId}/districts/${districtId}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Assign/move district to an area (or unassign)
  assignDistrictArea: async (districtId, areaId) => {
    try {
      const response = await api.put(`/admin/locations/districts/${districtId}/area`, { areaId });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Bulk assign multiple districts to an area
  bulkAssignDistricts: async (areaId, districtIds) => {
    try {
      const response = await api.post(`/admin/locations/areas/${areaId}/assign-districts`, { districtIds });
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default locationsService;
